import { blue } from '@mui/material/colors';
import styled from 'styled-components';

export const CardContentStyle = {
  display: 'flex',
  width: '100%',
  margin: 'auto',
  alignItems: 'flex-end',
  paddingTop: '0',
  paddingBottom: '.2rem',
};

export const CardInformation = styled.div`
  width: 90%;
`;

export const CardSettings = {
  width: '20%',
};

export const AvatarStyle = {
  width: 18,
  height: 18,
  fontSize: '.75rem',
};

export const AvatarGroupStyle = {
  '.MuiAvatarGroup-avatar': AvatarStyle,
  width: '5.2rem',
};

export default {
  CardContentStyle,
  CardInformation,
  CardSettings,
  AvatarStyle,
  AvatarGroupStyle,
};
